module.exports = __webpack_public_path__ + "static/media/BG_21.16e1d4d0.png";